import constants, { HTTP_METHODS } from '../../../settings/shared/constants'
import axiosClient from '../../common';

const _service = (options) => {
  options.baseURL = constants.utils.base.url;
  return axiosClient(options);
};


const getJwtHeader = () => {
  const jwtToken = localStorage.getItem('accessToken');
  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${jwtToken}`
  };
};

const getJwtWithApiTokenHeader = () => {
  const jwtToken = localStorage.getItem('accessToken');
  const profile = JSON.parse(localStorage.getItem('profile'));
  const apiToken = profile?.apiToken;

  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${jwtToken}`,
    "api-token": apiToken
  };
};


function getLLMList (){
  return _service({
    url: constants.utils.common.llms,
    method: HTTP_METHODS.GET,
    headers: getJwtWithApiTokenHeader()
  })
}

function getModelsByLLm(llmName) {
  return _service({
    url: constants.utils.common.models + "?llm_type=" + llmName,
    method: HTTP_METHODS.GET,
    headers: getJwtWithApiTokenHeader()
  })
}

function getHandlers (){
  return _service({
    url: constants.utils.common.handlers,
    method: HTTP_METHODS.GET,
    headers: getJwtWithApiTokenHeader()
  })
}

function getCodeview(projectId, userId, settingsTab = "frontend", options = {}) {
  const payload = {
    path: options?.path || "",
    file: options?.file || "",
  };

  return _service({
    url: `${constants.utils.codeview.getSource}${projectId}/${userId}?develop_mode=${settingsTab}`,
    method: HTTP_METHODS.POST,
    headers: getJwtHeader(),
    data: payload,
  })
}

/**
 * Normalize an S3 URI or key into the path expected by policy-sync.
 * e.g. s3://bucket-test/Cate/Subcate/file.json → /Cate/Subcate/file.json
 */
function toPolicySyncPath(s3Path) {
  if (!s3Path) return '';
  let path = String(s3Path).trim();
  if (path.startsWith('s3://')) {
    const withoutScheme = path.slice(5);
    const slashIdx = withoutScheme.indexOf('/');
    path = slashIdx >= 0 ? withoutScheme.slice(slashIdx) : `/${withoutScheme}`;
  }
  if (!path.startsWith('/')) path = `/${path}`;
  return path;
}

function getPolicyByPath(s3Path) {
  const path = toPolicySyncPath(s3Path);
  return _service({
    url: `${constants.utils.policySync.getPolicy}?path=${encodeURIComponent(path)}`,
    method: HTTP_METHODS.GET,
    headers: getJwtHeader(),
  });
}

//To export run function
const UtilService = {
  getLLMList, getModelsByLLm, getHandlers, getCodeview, getPolicyByPath, toPolicySyncPath
}
export default UtilService;
